import { UavEvents } from 'services/uav/types';

export const getUavAnalyticsUrl = (activityName: UavEvents) =>
    `/useractivityvault/v1/useractivity/${activityName}`;
